var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04698 3.29271C9.07692 3.20057 9.20726 3.20057 9.2372 3.29271L10.4667 7.0768C10.4801 7.118 10.5185 7.1459 10.5618 7.1459H14.5407C14.6375 7.1459 14.6778 7.26986 14.5994 7.3268L11.3805 9.6655C11.3454 9.69096 11.3308 9.7361 11.3442 9.7773L12.5737 13.5614C12.6036 13.6535 12.4982 13.7301 12.4198 13.6732L9.20087 11.3345C9.16582 11.309 9.11836 11.309 9.08331 11.3345L5.86437 13.6732C5.786 13.7301 5.68055 13.6535 5.71048 13.5614L6.94001 9.7773C6.9534 9.7361 6.93873 9.69096 6.90368 9.6655L3.68474 7.3268C3.60637 7.26986 3.64665 7.1459 3.74352 7.1459H7.72235C7.76567 7.1459 7.80407 7.118 7.81746 7.0768L9.04698 3.29271Z",
    stroke: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.65a7107cde48b3d67ed97e5af3c2b1f8.svg";
export { ForwardRef as ReactComponent };